import { defineStore } from 'pinia'

export const useMaterialReportStore = defineStore('materialReport', {
  state: () => ({
    showtip: true
  }),
  actions: {
    updateShowTip (value) {
      this.showtip = value
    }
  }
})
